import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

 const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .HSBGContainer': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 0,
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '80%',
      zIndex: 1,
      background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
    },
  },
  '& .HSContantContainer': {
    position: 'relative',
    zIndex: 2,
    padding: theme.spacing(23, 0, 14, 0),
    [theme.breakpoints.down('lg')]: {
    paddingTop: theme.spacing(15),
    },
  },

    '& .HSClubIcon':{
    width: theme.typography.pxToRem(51.6),
    height:theme.typography.pxToRem(60),
    },
    '& .HSBenfitItem':{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      gap : theme.spacing(1),
      '&:not(:last-child)': {
      marginBottom: theme.spacing(1),
    }
    },
    '& .HSBenfitItemIcon':{
      flex: '0 0 auto',
      fontSize: theme.spacing(3),
    },
    '& .HSImageGrid':{
        [theme.breakpoints.up('lg')]: {
          display: 'flex',
          alignItems: 'center',
        }
    },
    '& .HSMembershipImage':{
    width: '100%',
    height: theme.spacing(57.875),
    borderRadius: theme.spacing(2.5),
    overflow: 'hidden',
    [theme.breakpoints.down('lg')]: {
    height: theme.spacing(45.125),
    },
    [theme.breakpoints.down('md')]: {
    height: theme.spacing(31),
    },  
},
}));
export default StyledBox;